<div class="d-block d-lg-none position-absolute pointer" *ngIf="!isBottom" (click)="scrollDown()">
  <mat-icon>keyboard_arrow_down</mat-icon>
  <mat-icon>keyboard_arrow_down</mat-icon>
</div>
